import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { CourseBuilderStaticData } from "../../../_constants/staticData";
import Pagination from "../Teachers/MemberList/Pagination";
import editIcon from "../../../assets/icons/icon-edit.svg";

import deleteIcon from "../../../assets/icons/icon-delete.svg";
import moment from "moment";
import { Loading } from "../../Other/Loading";
import axiosInstance from "../../../axios";
import { DateRange } from "react-date-range";
import "../../Other/CustomAlert/CustomAlert";
import OverlayContainer from "../../Overlay/OverlayContainer";
import Forms from "../Forms";
import { downloadCSV } from "../../Other/utilities";

function StudentsList() {
  const [studentData, setStudentData] = useState([]);
  const [studentStats, setStudentStats] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [studentId, setStudentId] = useState(0);
  const [dateRangePicker, setDateRangePicker] = useState(false);
  const [modal, setModal] = useState(false);
  const [dateToggle, setDateToggle] = useState(false);
  const [editStudentData, setEditStudentData] = useState([]);
  const [accountLength, setAccountLength] = useState([]);

  const [filter, setFilter] = useState({
    status: "",
    startDate: "",
    endDate: "",
    page: 1,
    itemsPerPage: 10,
  });
  const [apiPages, setApiPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const refOne = useRef(null);

  const staticData = [
    {
      name: "Total Students",
      total: studentStats?.totalStudents || "0",
      boxShadow: "Dashboard-color-one",
      color: "color-one",
    },
    {
      name: "Active Students",
      total: studentStats?.activeStudents || "0",
      boxShadow: "Dashboard-color-two",
      color: "color-two",
    },
    {
      name: "Paid Students",
      total: studentStats?.paidStudents || "0",
      boxShadow: "Dashboard-color-three",
      color: "color-three",
    },
    {
      name: "Just Join",
      total: studentStats?.justJoined || "0",
      boxShadow: "Dashboard-color-four",
      color: "color-four",
    },
  ];

  const fetch = () => {
    axiosInstance
      .get(
        `user/student?status=${filter.status}&page=${filter.page}&perPage=${filter.itemsPerPage}&startDate=${filter.startDate}&endDate=${filter.endDate}`
      )
      .then((res) => {
        setLoading(false);
        setAccountLength(res.data.data);
        setStudentData(res.data?.data?.data);
        setApiPages(res.data.data.total_page);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };
  useEffect(() => {
    axiosInstance
      .get(`admin/student-statistics`)
      .then((res) => {
        setStudentStats(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    fetch();
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
  }, [filter, modal, confirmDelete]);

  const handleSelectChange = (e) => {
    setFilter({ ...filter, itemsPerPage: e.target.value });
  };

  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const hideOnEscape = (e) => {
    if (e.key === "Escape") {
      setDateToggle(false);
    }
  };

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setDateToggle(false);
    }
  };

  const handleDateRangeFilter = (item) => {
    setFilter({
      ...filter,
      startDate: moment(item.selection.startDate).format("YYYY-MM-D"),
      endDate: moment(item.selection.endDate).format("YYYY-MM-D"),
    });
    setRange([item.selection]);
  };

  const deleteStudent = (userId) => {
    setConfirmDelete(true);
    setStudentId(userId);
  };

  const handleDeleteStudent = () => {
    axiosInstance
      .post(`admin/user/delete/`, {
        userId: studentId,
      })
      .then((res) => {
        if (res) {
          setConfirmDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setConfirmDelete(false);
      });
  };

  const handleAddStudent = () => {
    setModal(true);
    setEditStudentData([]);
  };

  const handleEditStudent = (data) => {
    setModal(true);
    setEditStudentData(data);
  };

  const handleStatusFilter = (e) => {
    setFilter({ ...filter, status: e.target.value });
  };

  const handleStudentList = () => {
    axiosInstance
      .get(`/admin/export/students`)
      .then((res) => {
        downloadCSV(res?.data, "Student-list");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="width-0">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="dashboard-container-new">
            <p>Student List</p>
            <div>
              <button className="lastmonth-btn">Last Month</button>
              <button className="export-btn" onClick={handleStudentList}>
                Export
              </button>
            </div>
          </div>
          <div className="flex-dashboard-new-1">
            {staticData?.map((item, index) => (
              <div className={`box-shadow-06 ${item.boxShadow}`} key={index}>
                <p className="font-custom-p">{item.name}</p>
                <p className={`font-increase ${item.color}`}>{item.total}</p>
              </div>
            ))}
          </div>
          <div className="page-data-new">
            <div>
              {studentData?.length > 0 ? (
                <p className="showing-result">
                  Showing {filter.page} page of {filter.itemsPerPage} results
                </p>
              ) : (
                <p className="showing-result">Showing 0 result</p>
              )}
            </div>
            <div className="pagination-flex">
              <div className="pagination-add">
                {" "}
                <button onClick={handleAddStudent}>
                  Add <span>&#10009;</span>
                </button>
              </div>
              <div className="pagination-date">
                {dateRangePicker === false ? (
                  <>
                    <input
                      type="text"
                      placeholder="Date Range"
                      className="date-ranger-student"
                      onClick={() => {
                        setDateRangePicker(true);
                        setDateToggle(true);
                      }}
                    />
                  </>
                ) : (
                  <input
                    type="text"
                    value={`${moment(range[0].startDate).format(
                      "MM/DD/YYYY"
                    )} to ${moment(range[0].endDate).format("MM/DD/YYYY")}`}
                    placeholder="Date Range"
                    className="date-ranger-student-updated"
                    onClick={() => setDateToggle(true)}
                  />
                )}
                <div className="dateWrap" ref={refOne}>
                  {dateToggle && (
                    <DateRange
                      onChange={(item) => handleDateRangeFilter(item)}
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      ranges={range}
                      months={1}
                      direction="horizontal"
                      className="dateElement"
                    />
                  )}
                </div>
              </div>
              <div>
                <div className="pagination-select">
                  <select
                    className="select-dropdown-instructor-2"
                    onChange={handleStatusFilter}
                  >
                    <option value="">Select Status</option>
                    <option value="0">Pending</option>
                    <option value="1">Completed</option>
                  </select>
                </div>
              </div>
              <div>
                <p className="item-page-result">Item per page</p>
              </div>
              <div className="pagination-select">
                <select
                  className="select-dropdown-instructor-1"
                  onChange={(e) => handleSelectChange(e)}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          </div>
          <div className="instructor-table">
            {studentData?.length === 0 ? (
              <h2 className="no-data-found">No data found</h2>
            ) : (
              <table className="table-width-100">
                <thead>
                  <tr>
                    <th>Sr.no</th>
                    <th>Name</th>
                    <th>Student ID</th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>Phone Number</th>
                    <th>Register Date</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {studentData?.length > 0 ? (
                    studentData?.map((ele, index) => {
                      return (
                        <>
                          <tr key={index}>
                            <td className="cell">
                              {filter?.itemsPerPage * filter?.page -
                                filter?.itemsPerPage +
                                index +
                                1}
                            </td>
                            <td className="cell">
                              <div>
                                <img
                                  src="https://www.w3schools.com/w3images/avatar2.png"
                                  alt=""
                                  className="avatar-profile-image-02"
                                />
                                <p>{ele.firstName + " " + ele.lastName}</p>
                              </div>
                            </td>
                            <td className="cell">{ele.id}</td>
                            <td className="cell">{ele.userName}</td>
                            <td className="cell">{ele.email}</td>
                            <td className="cell">{ele.phoneNumber || "-"}</td>
                            <td className="cell">
                              {ele.createdAt
                                ? moment(ele?.createdAt).format("DD/MM/YYYY")
                                : "01/12/22"}
                            </td>
                            <td className="cell">
                              <span
                                style={{
                                  backgroundColor: ele.status
                                    ? "#d9f8ff"
                                    : "#f1e1fd",
                                }}
                              >
                                {ele?.status ? "Completed" : "Pending"}
                              </span>
                            </td>
                            <td className="cell">
                              <img
                                onClick={() => handleEditStudent(ele)}
                                src={editIcon}
                                alt="edit"
                              />
                            </td>
                            <td
                              className="cell"
                              onClick={() => deleteStudent(ele.id)}
                            >
                              <img src={deleteIcon} alt="delete" />
                            </td>
                          </tr>
                        </>
                      );
                    })
                  ) : (
                    <h2 className="no-data-found">No data found</h2>
                  )}
                </tbody>
              </table>
            )}
            {confirmDelete === true && (
              <OverlayContainer>
                <div className="alert-dialog-inner">
                  <div
                    className="alert-dialog-close"
                    onClick={() => setConfirmDelete(!confirmDelete)}
                  >
                    <div>
                      <i className="icon check"></i>
                    </div>
                  </div>
                  <div className="alert-title">Warning!</div>
                  <div className="alert-message">
                    {CourseBuilderStaticData.deleteStudentOverlay.header}
                  </div>

                  <div className="alert-close-btn">
                    <a className="btn-save" onClick={handleDeleteStudent}>
                      OK
                    </a>

                    <a
                      className="btn-cancel"
                      onClick={() => setConfirmDelete(false)}
                    >
                      CANCEL
                    </a>
                  </div>
                </div>
              </OverlayContainer>
            )}
          </div>
          {/* Pagination */}
          <div className="pageNumbers-sudents">
            {studentData?.length >= 0 ? (
              <Pagination
                className="pageNumbers-sudents"
                currentPage={filter.page}
                totalCount={filter.itemsPerPage}
                pageSize={apiPages}
                onPageChange={(page) => setFilter({ ...filter, page: page })}
              />
            ) : (
              ""
            )}
          </div>
          {modal && (
            <OverlayContainer>
              {/* Limit user warning shown here as per the plan  */}
              {accountLength.total < 177 ? (
                <Forms
                  setModal={setModal}
                  title="Student"
                  role={2}
                  editData={editStudentData}
                />
              ) : (
                <div className="alert-dialog-inner">
                  <div
                    className="alert-dialog-close"
                    onClick={() => setModal(false)}
                  >
                    <div>
                      <i className="icon check"></i>
                    </div>
                  </div>
                  <div className="alert-title">Warning!</div>
                  <div className="alert-message">
                    {
                      "Maximum user account limit reached. If you wish to add another user you have to upgrade your existing plan or delete existing user."
                    }
                  </div>

                  <div className="alert-close-btn">
                    <a className="btn-save" href="https://edusity.com/pricing">
                      UPGRADE PLAN
                    </a>

                    <a className="btn-cancel" onClick={() => setModal(false)}>
                      CANCEL
                    </a>
                  </div>
                </div>
              )}
            </OverlayContainer>
          )}
        </>
      )}
    </div>
  );
}

export default StudentsList;
